// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2Ulps","colMaxWidth":"Table_colMaxWidth__37Zue"};